
  import {detectCodeChange} from '@/utils/detectCodeChange'

  export default {
    setup() {
      const reload = () => {
        window.location.reload()
      }
      return {reload, needRefreshPage: detectCodeChange.changeDetected}
    }
  }
